import React, { Component } from 'react';
import QueryString from 'query-string';
import Agents from './Agents';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as agentActions from '~/store/modules/agents';
import constants from '~/constants.js';

class AgentsContainer extends Component {
  componentDidMount() {
    this.getAgents();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.getAgents();
    }
  }

  getAgents = () => {
    const { AgentsActions, location, section } = this.props;

    const query = QueryString.parse(location.search);

    // if directly refreshed the list url, set initial state from search query
    if (section === '') {
      // query.section must exist
      console.assert(
        query.section && query.section !== '',
        'Section must exist in this page.'
      );
      AgentsActions.selectSection(query.section);
      if (query.division) {
        AgentsActions.selectDivision(query.division);
      }
      if (query.kic) {
        AgentsActions.selectKic(query.kic);
      }
    }

    // call get API with params
    AgentsActions.getAgents({
      section:
        query.section !== ''
          ? constants.sections[query.section].name
          : undefined,
      division: query.division !== '' ? query.division : undefined,
      kic: query.kic !== '' ? query.kic : undefined,
    });
  };

  getNextAgents = () => {
    const {
      AgentsActions,
      location,
      section,
      currentPage,
      totalPages,
    } = this.props;

    console.assert(
      currentPage < totalPages,
      'GET_NEXT_AGENTS action must be called when currentPage is less than totalPages.'
    );

    const query = QueryString.parse(location.search);

    if (section === '') {
      // query.section must exist
      console.assert(
        query.section && query.section !== '',
        'Section must exist in this page.'
      );
      AgentsActions.selectSection(query.section);
      if (query.division) {
        AgentsActions.selectDivision(query.division);
      }
      if (query.kic) {
        AgentsActions.selectKic(query.kic);
      }
    }

    // call get API with params
    AgentsActions.getNextAgents({
      section:
        query.section !== ''
          ? constants.sections[query.section].name
          : undefined,
      division: query.division !== '' ? query.division : undefined,
      kic: query.kic !== '' ? query.kic : undefined,
      page: currentPage + 1,
    });
  };

  render() {
    return <Agents {...this.props} getNextAgents={this.getNextAgents} />;
  }
}

export default connect(
  ({ agents, pender }) => ({
    section: agents.section,
    sectionType: agents.sectionType,
    sectionName: agents.sectionName,
    division: agents.division,
    kic: agents.kic,
    agents: agents.agents,
    currentPage: agents.currentPage,
    totalPages: agents.totalPages,
    loadingAgents: pender.pending['agents/GET_AGENTS'],
    loadingMoreAgents: pender.pending['agents/GET_NEXT_AGENTS'],
  }),
  dispatch => ({
    AgentsActions: bindActionCreators(agentActions, dispatch),
  })
)(AgentsContainer);



// WEBPACK FOOTER //
// ./src/components/Agents/AgentsContainer.js